import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './ClientDashboard.css';

export default function ClientDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/client/login');
  };

  const toggleSidebar = () => setSidebarOpen(open => !open);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={`client-dashboard ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <aside className={`client-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="client-sidebar-header">
          <h2>Aurora Tech</h2>
          <p>Client Portal</p>
        </div>

        <nav className="client-sidebar-nav">
          <NavLink to="/client/dashboard" end className="client-nav-link">
            <span className="client-nav-icon">📦</span>
            <span>My Projects</span>
          </NavLink>
          <NavLink to="/client/dashboard/downloads" className="client-nav-link">
            <span className="client-nav-icon">📥</span>
            <span>Download History</span>
          </NavLink>
        </nav>

        <div className="client-sidebar-footer">
          <div className="client-user-info">
            <div className="client-user-avatar">{user?.name?.charAt(0)}</div>
            <div className="client-user-details">
              <div className="client-user-name">{user?.name}</div>
              <div className="client-user-email">{user?.email}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="client-logout-btn">
            Logout
          </button>
        </div>
      </aside>

      <div className="client-sidebar-overlay" onClick={closeSidebar} />

      <main className="client-content">
        <div className="client-mobile-header">
          <button className="client-hamburger" onClick={toggleSidebar} aria-label="Toggle menu">☰</button>
          <div className="client-mobile-title">Client Portal</div>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
